import React from 'react';

export default function EstimateSummaryItem(props) {
    return (
        <div className="statistic">
            <div className="number ui5-txt-not-important-small">{props.value}</div>
            <div className="label ui5-txt-not-important-small">{props.title}</div>
        </div>
    )
}